import React, { useState, useEffect } from 'react'
import logo from '../../Assets/logo.png';
import './ContactUsPage.css'; // Add this import

export default function HotChargeForm() {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    mobileNumber: '',
    occupation: '',
    fullAddress: '',
    pincode: '',
    state: '',
    city: '',
    message: ''
  })
  const [isMobile, setIsMobile] = useState(false);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    handleResize(); // Check initial size
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const validateForm = () => {
    let newErrors = {};
    if (!formData.firstName.trim()) newErrors.firstName = "First name is required";
    if (!formData.lastName.trim()) newErrors.lastName = "Last name is required";
    // You can add message validation if needed
    // if (!formData.message.trim()) newErrors.message = "Message is required";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData(prevData => ({
      ...prevData,
      [name]: value
    }))
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      const subject = encodeURIComponent("Contact Form Submission");
      const body = encodeURIComponent(
        `First Name: ${formData.firstName}\n` +
        `Last Name: ${formData.lastName}\n` +
        `Email: ${formData.email}\n` +
        `Mobile Number: ${formData.mobileNumber}\n` +
        `Occupation: ${formData.occupation}\n` +
        `Full Address: ${formData.fullAddress}\n` +
        `Pincode: ${formData.pincode}\n` +
        `State: ${formData.state}\n` +
        `City: ${formData.city}\n` +
        `Message: ${formData.message}`
      );
      window.location.href = `mailto:info@hotcharge.in?subject=${subject}&body=${body}`;
    }
  }

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '100vh',
      backgroundColor: '#1A2933'
    }}>
      <div style={{
        width: '100%',
        maxWidth: '900px',
        backgroundColor: 'white',
        borderRadius: '8px',
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
        overflow: 'hidden',
        display: isMobile ? 'block' : 'flex'
      }}>
        <div style={{
          width: '33%',
          padding: '2rem',
          display: 'flex',
          flexDirection: 'column',
        //   justifyContent: 'center',
          alignItems: 'center'
        }}>
          <img 
            src={logo} 
            alt="Hot Charge Logo" 
            style={{ width: '140px', height: '100px' }}
          />
        </div>
        <div style={{ width: '67%', padding: '2rem' }}>
          <form onSubmit={handleSubmit} style={{ display: 'grid', gap: '1rem' }}>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
              <div>
                <input
                  type="text"
                  placeholder="First Name"
                  name="firstName"
                  value={formData.firstName}
                  onChange={handleChange}
                  className={`contact-input ${errors.firstName ? 'error' : ''}`}
                />
                {errors.firstName && <span className="error-message">{errors.firstName}</span>}
              </div>
              <div>
                <input
                  type="text"
                  placeholder="Last Name"
                  name="lastName"
                  value={formData.lastName}
                  onChange={handleChange}
                  className={`contact-input ${errors.lastName ? 'error' : ''}`}
                />
                {errors.lastName && <span className="error-message">{errors.lastName}</span>}
              </div>
            </div>
            <div>
              <input
                type="email"
                placeholder="Email Address"
                name="email"
                value={formData.email}
                onChange={handleChange}
                className={`contact-input ${errors.email ? 'error' : ''}`}
              />
              {errors.email && <span className="error-message">{errors.email}</span>}
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
              <div>
                <input
                  type="tel"
                  placeholder="Mobile Number"
                  name="mobileNumber"
                  value={formData.mobileNumber}
                  onChange={handleChange}
                  className={`contact-input ${errors.mobileNumber ? 'error' : ''}`}
                />
                {errors.mobileNumber && <span className="error-message">{errors.mobileNumber}</span>}
              </div>
              <div>
                <input
                  type="text"
                  placeholder="Occupation"
                  name="occupation"
                  value={formData.occupation}
                  onChange={handleChange}
                  className={`contact-input ${errors.occupation ? 'error' : ''}`}
                />
                {errors.occupation && <span className="error-message">{errors.occupation}</span>}
              </div>
            </div>
            <div>
              <input
                type="text"
                placeholder="Full Address"
                name="fullAddress"
                value={formData.fullAddress}
                onChange={handleChange}
                className={`contact-input ${errors.fullAddress ? 'error' : ''}`}
              />
              {errors.fullAddress && <span className="error-message">{errors.fullAddress}</span>}
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '1rem' }}>
              <div>
                <input
                  type="text"
                  placeholder="Pincode"
                  name="pincode"
                  value={formData.pincode}
                  onChange={handleChange}
                  className={`contact-input ${errors.pincode ? 'error' : ''}`}
                />
                {errors.pincode && <span className="error-message">{errors.pincode}</span>}
              </div>
              <div>
                <input
                  type="text"
                  placeholder="State"
                  name="state"
                  value={formData.state}
                  onChange={handleChange}
                  className={`contact-input ${errors.state ? 'error' : ''}`}
                />
                {errors.state && <span className="error-message">{errors.state}</span>}
              </div>
              <div>
                <input
                  type="text"
                  placeholder="City"
                  name="city"
                  value={formData.city}
                  onChange={handleChange}
                  className={`contact-input ${errors.city ? 'error' : ''}`}
                />
                {errors.city && <span className="error-message">{errors.city}</span>}
              </div>
            </div>
            <div>
              <textarea
                placeholder="Message"
                name="message"
                value={formData.message}
                onChange={handleChange}
                rows={4}
                className={`contact-input ${errors.message ? 'error' : ''}`}
              />
              {errors.message && <span className="error-message">{errors.message}</span>}
            </div>
            <button
              type="submit"
              style={{
                backgroundColor: 'black',
                color: 'white',
                padding: '0.5rem 1rem',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer',
                fontSize: '1rem'
              }}
            >
              Submit
            </button>
          </form>
        </div>
      </div>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/ContactUsPage/ContactUsPage.js